import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function UrgencySection() {
  // Set target date to 48 hours from now on first load
  const [timeLeft, setTimeLeft] = useState({
    days: 1,
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Simple countdown logic for demonstration
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        if (prev.days > 0) return {
          ...prev,
          days: prev.days - 1,
          hours: 23,
          minutes: 59,
          seconds: 59
        };
        return prev; // Timer ended
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handleCheckout = () => {
    window.location.href = 'https://productosdigitalesnuevos.myshopify.com/checkouts/cn/hWN9n9b8dLQ0zWcM4lh6BQg6/es-ar?_r=AQAB3sxDrVfYMB8G5oC3KtOEXxVl3WNVcpKRPbVzMknQ1i0&cart_link_id=QdC5wTSR&preview_theme_id=146146721979';
  };
  return <section className="py-12 bg-[#d4a843] text-[#1a1008]" data-id="element-172">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-173">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-174">
          <Timer className="w-8 h-8" data-id="element-175" />
          <h2 className="text-2xl md:text-4xl font-extrabold uppercase tracking-tight" data-id="element-176">
            Esta oferta termina pronto
          </h2>
        </div>

        <div className="flex justify-center gap-4 md:gap-8 mb-8" data-id="element-177">
          <div className="flex flex-col items-center" data-id="element-178">
            <div className="bg-[#1a1008] text-white text-3xl md:text-5xl font-bold w-16 h-16 md:w-24 md:h-24 flex items-center justify-center rounded-xl shadow-lg" data-id="element-179">
              {'00'}
            </div>
            <span className="mt-2 font-bold text-sm md:text-base uppercase" data-id="element-180">
              Días
            </span>
          </div>
          <div className="text-3xl md:text-5xl font-bold mt-2 md:mt-4" data-id="element-181">:</div>
          <div className="flex flex-col items-center" data-id="element-182">
            <div className="bg-[#1a1008] text-white text-3xl md:text-5xl font-bold w-16 h-16 md:w-24 md:h-24 flex items-center justify-center rounded-xl shadow-lg" data-id="element-183">
              {'00'}
            </div>
            <span className="mt-2 font-bold text-sm md:text-base uppercase" data-id="element-184">
              Horas
            </span>
          </div>
          <div className="text-3xl md:text-5xl font-bold mt-2 md:mt-4" data-id="element-185">:</div>
          <div className="flex flex-col items-center" data-id="element-186">
            <div className="bg-[#1a1008] text-white text-3xl md:text-5xl font-bold w-16 h-16 md:w-24 md:h-24 flex items-center justify-center rounded-xl shadow-lg" data-id="element-187">
              {'10'}
            </div>
            <span className="mt-2 font-bold text-sm md:text-base uppercase" data-id="element-188">
              Minutos
            </span>
          </div>
          <div className="text-3xl md:text-5xl font-bold mt-2 md:mt-4" data-id="element-189">:</div>
          <div className="flex flex-col items-center" data-id="element-190">
            <div className="bg-[#1a1008] text-white text-3xl md:text-5xl font-bold w-16 h-16 md:w-24 md:h-24 flex items-center justify-center rounded-xl shadow-lg" data-id="element-191">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <span className="mt-2 font-bold text-sm md:text-base uppercase" data-id="element-192">
              Segundos
            </span>
          </div>
        </div>

        <p className="text-lg md:text-xl font-semibold mb-8" data-id="element-193">
          El precio volverá a $49.990 cuando termine el contador.
        </p>

        <button onClick={handleCheckout} className="bg-[#1a1008] text-white px-8 py-4 rounded-full text-xl font-bold hover:bg-black transition-colors shadow-xl hover:scale-105 transform duration-300" data-id="element-194">
          Aprovechar Descuento Ahora
        </button>
      </div>
    </section>;
}